import { useIntl } from 'react-intl';
import { IconSettings } from '@rossum/ui/icons/tabler';
import { Stack, Typography } from '@rossum/ui/material';
import { useSetupEngineSchema } from '../../legacy-engines/hooks/useSetupEngineSchema';
import { useInfiniteDedicatedEngines } from '../hooks/useInfiniteDedicatedEngines';
import { EngineTile } from './EngineTile';
import { ShowMoreButton } from './ShowMoreButton';
import { TilesList } from './TilesList';
import { TilesListEmptyState } from './TilesListEmptyState';

const DedicatedEnginesList = () => {
  const intl = useIntl();

  const {
    data: engines,
    fetchNextPage,
    hasNextPage,
    isFetching,
    status,
  } = useInfiniteDedicatedEngines({
    pageSize: 10,
    ordering: ['-id'],
  });

  const { handleOnClick, isLoading } = useSetupEngineSchema();

  const allEngines = engines?.pages.flatMap(page => page.results);

  return (
    <TilesList
      title={intl.formatMessage({
        id: 'components.dedicatedEnginesList.title',
      })}
      items={allEngines}
      renderTile={engine => (
        <EngineTile
          key={engine.id}
          engine={engine}
          quickActions={
            engine.status !== 'draft'
              ? undefined
              : [
                  {
                    key: 'configure',
                    iconProps: {
                      Icon: IconSettings,
                      state: false,
                      disabled: isLoading,
                    },
                    tooltip: intl.formatMessage({
                      id: 'components.engineCard.actionButton',
                    }),
                    disabled: isLoading,
                    onClick: () => handleOnClick(engine.id, !!engine.schema),
                    'data-cy': 'engines-configure-engine',
                  },
                ]
          }
        />
      )}
      status={status}
      emptyState={
        <TilesListEmptyState
          title={intl.formatMessage({
            id: 'components.dedicatedEnginesList.noEngines',
          })}
        />
      }
      errorState={
        <Stack justifyContent="center" direction="row">
          <Typography variant="body2" color="text.secondary">
            {intl.formatMessage({
              id: 'components.dedicatedEnginesList.errorFetchingEngines',
            })}
          </Typography>
        </Stack>
      }
      buttons={
        hasNextPage
          ? [
              <ShowMoreButton
                key="show-more-results"
                onClick={fetchNextPage}
                isFetching={isFetching}
              />,
            ]
          : []
      }
    />
  );
};

export { DedicatedEnginesList };
